/** Tema claro/escuro.
 *
 *  Três opções: seguir o sistema operacional, ou fixar claro/escuro. A escolha
 *  fica no navegador de quem usa — não no cadastro — porque o mesmo login é
 *  usado no balcão com luz e na sala de leitura no escuro, e o que vale é onde
 *  a pessoa está agora.
 *
 *  Quem aplica é o atributo `data-tema` no <html>, resolvido sempre para
 *  'claro' ou 'escuro'. O CSS não precisa saber de `prefers-color-scheme`, e
 *  isso evita duplicar a tabela de tokens dentro de uma media query.
 */

export type Tema = 'auto' | 'claro' | 'escuro';

const CHAVE = 'rx-tema';

export function temaSalvo(): Tema {
  const t = localStorage.getItem(CHAVE);
  return t === 'claro' || t === 'escuro' ? t : 'auto';
}

export function resolver(tema: Tema): 'claro' | 'escuro' {
  if (tema !== 'auto') return tema;
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'escuro' : 'claro';
}

export function aplicar(tema: Tema) {
  const efetivo = resolver(tema);
  const raiz = document.documentElement;
  raiz.dataset.tema = efetivo;
  // `color-scheme` faz o navegador acompanhar: barra de rolagem, caixas de
  // seleção de data e o fundo padrão antes do CSS carregar.
  raiz.style.colorScheme = efetivo === 'escuro' ? 'dark' : 'light';
}

export function salvar(tema: Tema) {
  if (tema === 'auto') localStorage.removeItem(CHAVE);
  else localStorage.setItem(CHAVE, tema);
  aplicar(tema);
}

/** Enquanto estiver em 'auto', segue o sistema operacional em tempo real —
 *  inclusive quando o Windows troca sozinho no fim da tarde. */
export function acompanharSistema(aoMudar: () => void) {
  const consulta = window.matchMedia('(prefers-color-scheme: dark)');
  const ouvinte = () => {
    if (temaSalvo() === 'auto') {
      aplicar('auto');
      aoMudar();
    }
  };
  consulta.addEventListener('change', ouvinte);
  return () => consulta.removeEventListener('change', ouvinte);
}
